var _class, _Tabs;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import classNames from "classnames";
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Component } from "react";
import { withTranslation } from "react-i18next";
import styled from "styled-components";
import defined from "terriajs-cesium/Source/Core/defined";
import MappableMixin from "../../ModelMixins/MappableMixin";
import DataCatalogTab from "./Tabs/DataCatalogTab";
import MyDataTab from "./Tabs/MyDataTab/MyDataTab";
import Styles from "./tabs.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let Tabs = observer(_class = (_Tabs = class Tabs extends Component {
  async onFileAddFinished(files) {
    const file = files.find(f => MappableMixin.isMixedInto(f));
    if (file) {
      const result = await this.props.viewState.viewCatalogMember(file);
      if (result.error) {
        result.raiseError(this.props.terria);
      } else {
        if (!file.disableZoomTo) {
          this.props.terria.currentViewer.zoomTo(file, 1);
        }
      }
    }
    this.props.viewState.myDataIsUploadView = false;
  }
  async onUrlAddFinished() {
    this.props.viewState.openAddData();
  }
  getTabs() {
    const {
      t
    } = this.props;
    // This can be passed in as prop
    if (this.props.tabs) {
      return this.props.tabs;
    }
    const myDataTab = {
      title: "my-data",
      name: t("addData.myData"),
      category: "my-data",
      panel: /*#__PURE__*/_jsx(MyDataTab, {
        terria: this.props.terria,
        viewState: this.props.viewState,
        onFileAddFinished: files => this.onFileAddFinished(files),
        onUrlAddFinished: () => this.onUrlAddFinished()
      })
    };
    if (this.props.terria.configParameters.tabbedCatalog) {
      return [].concat(this.props.terria.catalog.group.memberModels.filter(member => member !== this.props.terria.catalog.userAddedDataGroup).map(member => ({
        name: member.nameInCatalog,
        title: "data-catalog-".concat(member.name),
        category: "data-catalog",
        idInCategory: member.uniqueId,
        panel: /*#__PURE__*/_jsx(DataCatalogTab, {
          items: member.memberModels || [member],
          searchPlaceholder: t("addData.searchPlaceholderWhole")
        })
      })), [myDataTab]);
    } else {
      return [{
        name: t("addData.data"),
        title: "data-catalog",
        category: "data-catalog",
        panel: /*#__PURE__*/_jsx(DataCatalogTab, {
          items: this.props.terria.catalog.group.memberModels,
          searchPlaceholder: t("addData.searchPlaceholder")
        })
      }, myDataTab];
    }
  }
  async activateTab(category, idInCategory) {
    runInAction(() => {
      this.props.viewState.activeTabCategory = category;
      if (this.props.terria.configParameters.tabbedCatalog) {
        this.props.viewState.activeTabIdInCategory = idInCategory;
        if (category === "data-catalog") {
          const member = this.props.terria.catalog.group.memberModels.filter(m => m.uniqueId === idInCategory)[0];
          // If member was found and member can be opened, open it (causes CkanCatalogGroups to fetch etc.)
          if (defined(member)) {
            this.props.viewState.viewCatalogMember(member).then(result => result.raiseError(this.props.viewState.terria));
          }
        }
      }
    });
  }
  render() {
    const tabs = this.getTabs();
    const sameCategory = tabs.filter(t => t.category === this.props.viewState.activeTabCategory);
    const currentTab = sameCategory.filter(t => t.idInCategory === this.props.viewState.activeTabIdInCategory)[0] || sameCategory[0] || tabs[0];
    return /*#__PURE__*/_jsxs("div", {
      className: Styles.tabs,
      children: [/*#__PURE__*/_jsx("ul", {
        className: Styles.tabList,
        role: "tablist",
        style: {
          padding: "10px 24px",
          background: "#fff"
        },
        children: tabs.map((item, i) => /*#__PURE__*/_jsx("li", {
          id: "tablist--" + item.title,
          className: Styles.tabListItem,
          role: "tab",
          "aria-controls": "panel--" + item.title,
          "aria-selected": item === currentTab,
          children: /*#__PURE__*/_jsx(ButtonTab, {
            type: "button",
            onClick: this.activateTab.bind(this, item.category, item.idInCategory),
            className: classNames(Styles.btnTab, {
              [Styles.btnSelected]: item === currentTab
            }),
            isCurrent: item === currentTab,
            children: item.name
          })
        }, i))
      }), /*#__PURE__*/_jsx("section", {
        id: "panel--" + currentTab.title,
        className: classNames(Styles.tabPanel, Styles.isActive),
        "aria-labelledby": "tablist--" + currentTab.title,
        role: "tabpanel",
        tabIndex: "0",
        children: /*#__PURE__*/_jsx("div", {
          className: Styles.panelContent,
          children: currentTab.panel
        })
      }, currentTab.title)]
    });
  }
}, _defineProperty(_Tabs, "propTypes", {
  terria: PropTypes.object.isRequired,
  viewState: PropTypes.object.isRequired,
  tabs: PropTypes.array,
  t: PropTypes.func.isRequired
}), _Tabs)) || _class;
const ButtonTab = styled.button.withConfig({
  displayName: "Tabs__ButtonTab",
  componentId: "sc-nncheo-0"
})(["", ""], props => "\n    /* overrides padding and margin in scss */\n    padding: 10px 12px;\n    margin: 0;\n\n    background: transparent;\n    color: ".concat(props.theme.dark, ";\n    border: 1px solid transparent;\n    &:hover,\n    &:focus {\n      background: ").concat(props.theme.textLight, ";\n      ").concat(props.isCurrent && "border: 1px solid ".concat(props.theme.greyLighter, ";"), "\n    }\n    ").concat(props.isCurrent && "\n      background: ".concat(props.theme.textLight, ";\n      border: 1px solid ").concat(props.theme.greyLighter, ";\n    "), "\n\n  "));
export default withTranslation()(Tabs);